"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _react = _interopRequireWildcard(require("react"));

var _context = require("../context");

var _constants = require("../popover/constants");

var _utils = require("../utils");

var _core = require("@emotion/core");

var TriggerWrapper = (0, _context.styledWithTheme)('div')(function (_ref) {
  var isInline = _ref.isInline,
      theme = _ref.theme,
      verticalAlign = _ref.verticalAlign;
  return (0, _objectSpread2.default)({
    alignItems: 'center',
    display: 'inline-flex',
    justifyContent: 'center',
    verticalAlign: verticalAlign,
    ':focus': {
      outline: "2px solid ".concat(theme.selectors.color('primary70')),
      outlineOffset: 2
    }
  }, isInline ? {} : {
    minHeight: _utils.A11Y_MIN_SIZE,
    minWidth: _utils.A11Y_MIN_SIZE
  });
});
TriggerWrapper.displayName = 'TriggerWrapper';

var TooltipTrigger = function TooltipTrigger(_ref2) {
  var isInline = _ref2.isInline,
      triggerRef = _ref2.triggerRef,
      tooltipRef = _ref2.tooltipRef,
      WrappedComponent = _ref2.WrappedComponent,
      useTriggerWrapper = _ref2.useTriggerWrapper,
      onKeyDown = _ref2.onKeyDown,
      open = _ref2.open,
      close = _ref2.close,
      tooltipId = _ref2.tooltipId,
      tooltipDataTestId = _ref2.tooltipDataTestId,
      verticalAlign = _ref2.verticalAlign,
      passthroughProps = (0, _objectWithoutProperties2.default)(_ref2, ["isInline", "triggerRef", "tooltipRef", "WrappedComponent", "useTriggerWrapper", "onKeyDown", "open", "close", "tooltipId", "tooltipDataTestId", "verticalAlign"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  var handleMouseMove = function handleMouseMove(e) {
    var clientX = e.clientX,
        clientY = e.clientY; // detect boundaries of tooltip trigger and tooltip body to not close them on hovering

    if (triggerRef.current) {
      var _triggerRef$current$g = triggerRef.current.getBoundingClientRect(),
          triggerTop = _triggerRef$current$g.top,
          triggerLeft = _triggerRef$current$g.left,
          triggerBottom = _triggerRef$current$g.bottom,
          triggerRight = _triggerRef$current$g.right;

      if (clientX >= triggerLeft && clientX <= triggerRight && clientY >= triggerTop && clientY <= triggerBottom) {
        return;
      }
    }

    if (tooltipRef.current) {
      var _tooltipRef$current$g = tooltipRef.current.getBoundingClientRect(),
          tooltipTop = _tooltipRef$current$g.top,
          tooltipLeft = _tooltipRef$current$g.left,
          tooltipBottom = _tooltipRef$current$g.bottom,
          tooltipRight = _tooltipRef$current$g.right;

      if (clientX >= tooltipLeft && clientX <= tooltipRight && clientY >= tooltipTop - _constants.ARROW_HEIGHT && clientY <= tooltipBottom + _constants.ARROW_HEIGHT) {
        return;
      }
    }

    document.removeEventListener('mousemove', handleMouseMove);
    close();
  };

  var handleMouseOver = function handleMouseOver() {
    document.addEventListener('mousemove', handleMouseMove);
    open();
  };

  var toggleIsFocused = function toggleIsFocused() {
    if (isFocused) {
      close();
    } else {
      open();
    }

    setIsFocused(!isFocused);
  };

  (0, _react.useEffect)(function () {
    return function () {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);
  var triggerProps = {
    tabIndex: 0,
    role: 'button',
    'aria-describedby': tooltipId,
    onMouseOver: handleMouseOver,
    onFocus: toggleIsFocused,
    onBlur: toggleIsFocused
  };

  if (useTriggerWrapper) {
    var dataTestProps = (0, _utils.buildDataTestProps)({
      dataTestComponent: 'StencilReactTooltipTrigger',
      dataTestId: tooltipDataTestId
    });
    return (0, _core.jsx)(TriggerWrapper, (0, _extends2.default)({
      isInline: isInline
    }, dataTestProps, triggerProps, {
      onKeyDown: onKeyDown,
      ref: triggerRef,
      verticalAlign: verticalAlign
    }), (0, _core.jsx)(WrappedComponent, passthroughProps));
  }

  return (0, _core.jsx)(WrappedComponent, (0, _extends2.default)({}, triggerProps, passthroughProps, {
    ref: triggerRef
  }));
};

var _default = TooltipTrigger;
exports.default = _default;